export var ONLINE_STORES_SPECS;
(function (ONLINE_STORES_SPECS) {
    ONLINE_STORES_SPECS["UseAddToCurrentCart"] = "specs.stores.UseAddToCurrentCart";
    ONLINE_STORES_SPECS["UseCurrentCartFromSdk"] = "specs.stores.UseCurrentCartFromSdk";
})(ONLINE_STORES_SPECS || (ONLINE_STORES_SPECS = {}));
//# sourceMappingURL=constants.js.map